exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pretty[data-v-abc62744]{margin-top:13px}.form-field.disabled[data-v-abc62744]{opacity:.25}.disclaimer[data-v-abc62744]{font-family:PT Sans Narrow,sans-serif;font-size:13px;color:#6f8695}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-abc62744","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/residents/ResidentRefundPreview.vue
// module id = ac2u
// module chunks = 0 1